<template>
  <section class="sm-reports__main">
    <components 
      :is="currentTab"
      :reqCSV="reqCSV" 
      :reqPDF="reqPDF"
      :isGlobalReport="currentTab === 'global-report'"
      @finishCSV="$emit('finishCSV')"
      @finishPDF="$emit('finishPDF')"
    />
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'reports-main',
  components: {
    'charge': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/reports/components/Charge.vue'),
    'mail': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/reports/components/Mail.vue'),
    'customers': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/reports/components/Customers.vue'),
    'global-report': () => import(/* webpackPrefetch: true */ '@/views/admin/OrgReports.vue'),
    'sales': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/reports/components/Sales.vue'),
    'yearly-revenue': () => import(/* webpackPrefetch: true */ '@/views/admin/pages/reports/components/YearlyRevenue.vue')
  },
  props: {
    reqCSV: {
      type: Boolean,
      default: false
    },
    reqPDF: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentTab: null,
      allTabs: [
        'charge',
        'mail',
        'customers',
        'global-report',
        'sales',
        'yearly-revenue'
      ]
    };
  },
  created() {
    this.updateCurrentTab();
  },
  computed: {
    ...mapGetters({
      userAccount: 'account/userAccount',
    })
  },
  methods: {
    updateCurrentTab() {
      let query = this.$route.query;
      if (query.tab && this.allTabs.includes(query.tab)) {
        this.currentTab = query.tab;
      } else {
        this.currentTab =  this.allTabs[0];
      }
    },
  },
  watch: {
    '$route.query'() {
      this.updateCurrentTab();
    },
    userAccount(val) {
      if(val && val.role && val.role === 'mail_admin') {
        this.$router.push('/');
      }
    }
  }
}
</script>
